(function () {
  window.onscroll = function () {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    if (scrollTop > 100) {
      document.querySelector('#goTop').classList.add('show');
      return;
    }
    document.querySelector('#goTop').classList.remove('show');
  };
})();
